<template>
    <div class="video-grid">
        <div v-if="!videos || videos.length === 0" class="empty-state">
            No videos found (videos: {{ videos ? videos.length : 'null' }})
        </div>
        <div v-else :class="`video-container col-${cols}`">
            <div v-for="video in videos" :key="video.id" class="video-item">
                <video-thumb :video="video" :user-images="userImages"></video-thumb>
            </div>
        </div>
    </div>
</template>

<script>
import VideoThumb from '../components/VideoThumb.vue'
// import { Storage } from "@aws-amplify/storage"
export default {
    name: 'video-grid-view',
    components: {
        VideoThumb
    },
    props: {
        videos: {
            type: Array,
            default() {
                return []
            }
        },
        userImages: {
            type: Array,
            default() {
                return []
            }
        },
        cols: {
            type: Number,
            default: 3
        }
    },
    created() {
        console.log('VideoGrid created with videos:', this.videos);
    },
    watch: {
        videos: {
            handler(newVideos) {
                console.log('Videos updated:', newVideos);
            },
            deep: true
        }
    },
    methods: {
        
    }
}
</script>

<style scoped>
.video-grid {
    width: 100%;
}

.video-container {
    display: grid;
    gap: 20px;
    padding: 20px;
}

.video-container.col-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.video-container.col-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.video-item {
    width: 100%;
    min-width: 0;
}

.empty-state {
    text-align: center;
    padding: 40px;
    color: var(--text-tertiary);
    font-size: 18px;
}

@media (max-width: 1200px) {
    .video-container.col-3,
    .video-container.col-4 {
        grid-template-columns: repeat(2, minmax(0, 360px));
    }
}

@media (max-width: 768px) {
    .video-container.col-3,
    .video-container.col-4 {
        grid-template-columns: minmax(0, 400px);
        justify-content: center;
    }
}
</style>
